import gql from 'graphql-tag'

export default gql`mutation ycmdMessageForward($message_id: ID, $to_user_id: ID, $to_user_ids: [ID]) {
	ycmdMessageForward(message_id: $message_id, to_user_id: $to_user_id, to_user_ids: $to_user_ids, client: "portal") {
		status
		data
	}
}`
